import React from "react";
import { Eraser, Play } from "lucide-react";
import styles from './DocumentProcessor.module.css';

export default function TopControls({
    onSubmit,
    onClear,
    disabled,
    inputMode,
    inputText,
    selectedFile,
    hideFileSubmit = false,
    catalogAppearance = false,
}) {
    const canSubmit =
        !disabled &&
        ((inputMode === "text" && inputText.trim()) ||
            (inputMode === "excel" && selectedFile));
    const showSubmit = !(inputMode === "excel" && hideFileSubmit);

    return (
        <div className={styles.buttonGroup}>
            {catalogAppearance && inputMode === "text" && <span className={styles.inputHint}>Каждая позиция с новой строки</span>}
            {showSubmit && (
                <button
                    className={`${styles.btn} ${canSubmit ? styles.btnBlue : ""} ${catalogAppearance ? styles.submitButton : ""}`}
                    disabled={!canSubmit}
                    onClick={onSubmit}
                >
                    {catalogAppearance && <Play size={23} aria-hidden="true" />}
                    {disabled ? "Обработка..." : "Обработать"}
                </button>
            )}

            <button
                className={`${styles.btn} ${catalogAppearance ? styles.clearButton : styles.btnBlue}`}
                onClick={onClear}
            >
                {catalogAppearance && <Eraser size={23} aria-hidden="true" />}
                Очистить
            </button>
        </div>
    );
}
